import React, { useState, useEffect } from "react";
import configuration from "../../config";
import { toast } from "react-toastify";
import Loader from "../../components/Loader/Loader";
import Breadcrumb from "../../parts/Breadcrumb";
import labels from "../../constants/Withdraw";
import ListSection from "../../components/ListSection";
let Id = "";
// List Settings
function Summary() {
  const [isLoader, setIsLoader] = useState(false);
  const columns = [
    {
      title: "ID",
      field: "withdraw_request_id",
    },
    { title: "User ID", field: "user_id" },
    {
      title: "User Name",
      field: "first_name",
      render: (rowData) => (
        <span>{rowData.first_name + " " + rowData.last_name}</span>
      ),
    },
    {
      title: "Mobile",
      field: "mobile",
      render: (rowData) => (
        <span>{rowData.mobile_country_code + " " + rowData.mobile}</span>
      ),
    },
    { title: "Amount", field: "amount" },
    { title: "Date", field: "created_at" },
    {
      title: "User Type",
      field: "user_type",
      render: (rowData) => (
        <span className="capitalize">{rowData.user_type}</span>
      ),
    },
    {
      title: "Status",
      field: "status",
      render: (rowData) => (
        <span
          className={
            rowData.status === "approve"
              ? "inline-flex items-center px-3 py-0.5 rounded-full text-basefont-medium bg-green-100 text-green-800 capitalize"
              : "inline-flex items-center px-3 py-0.5 rounded-full text-basefont-medium bg-red-100 text-red-800 capitalize"
          }
        >
          {" "}
          {rowData.status === "approve" ? "approved" : "rejected"}
        </span>
      ),
    },
    {
      title: "Action",
      field: "status",
      width: "5%",
      render: (rowData) =>
        rowData.status === "pending" ? (
          <>
            <button
              onClick={(e) =>
                handleAction("approve", rowData.withdraw_request_id)
              }
              type="button"
              className="mt-3 mr-3 inline-flex items-center px-3 py-2 border border-transparent text-baseleading-4 font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              Approve
            </button>
            <button
              onClick={(e) =>
                handleAction("reject", rowData.withdraw_request_id)
              }
              type="button"
              className="mt-3 inline-flex items-center px-3 py-2 border border-1 text-baseleading-4 font-medium rounded-md shadow-sm text-indigo-600 bg-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              Reject
            </button>
          </>
        ) : (
          ""
        ),
    },
  ];
  const [data, setData] = useState([]);
  const onSelectionChange = (e) => {};
  useEffect(() => {
    getData();
  }, []);

  function getData() {
    setIsLoader(true);
    var url = window.location.href;
    Id = url.substring(url.lastIndexOf("/") + 1);
    configuration
      .getAPI({
        url: "sub-user/withdraw-list",
        params: {},
      })
      .then((data) => {
        if (data.status === 200) {
          setData(data.payload);
        }
        setIsLoader(false);
      })
      .catch((error) => {
        setIsLoader(false);
        return toast.error(error.message);
      });
  }
  function handleAction(type, request_id) {
    setIsLoader(true);
    configuration
      .postAPI({
        url: "sub-user/withdraw-action",
        params: { type, withdraw_request_id: request_id },
      })
      .then((data) => {
        if (data.status === 200) {
          getData();
          setIsLoader(false);
          return toast.success(
            type === "approve"
              ? "The withdrawal request has been approved successfully."
              : "The withdrawal request has been rejected successfully."
          );
        } else if (data.error) {
          setIsLoader(false);
          return toast.error(data.error.message);
        } else {
          setIsLoader(false);
          return toast.error("Something went wrong");
        }
      })
      .catch((error) => {
        setIsLoader(false);
        return toast.error(error.message);
      });
  }

  return (
    <>
      {isLoader ? <Loader /> : ""}
      <Breadcrumb module={labels.WithdrawRequest} />
      <ListSection
        captionTitle="View Withdrawal Requests"
        columns={columns}
        data={data}
        handleAction={handleAction}
        onSelectionChange={onSelectionChange}
        disabledCheckbox={true}
      />
    </>
  );
}

export default Summary;
